// User roles in the system
export enum UserRoles {
  ADMIN = 1,  // Team/Organization admin
  MANAGER = 2, // Team/Organization manager
  MEMBER = 3   // Regular team member
}

export default UserRoles; 